module.exports = __webpack_public_path__ + "img/icon_appkaifa.699163ca.png";